/** Validate an expense record; returns { valid: boolean, errors: string[] } */
export function validateExpense(expense) {
  const errors = [];

  if (!expense.date) {
    errors.push('Date is required');
  } else {
    const d = new Date(expense.date);
    const today = new Date();
    today.setHours(23, 59, 59, 999);
    if (isNaN(d.getTime())) {
      errors.push('Date is invalid');
    } else if (d > today) {
      errors.push('Date cannot be in the future');
    }
  }

  if (!expense.vendor || String(expense.vendor).trim().length === 0) {
    errors.push('Vendor / merchant name is required');
  } else if (String(expense.vendor).trim().length > 100) {
    errors.push('Vendor name must be 100 characters or fewer');
  }

  const amount = Number(expense.amount);
  if (isNaN(amount) || amount <= 0) {
    errors.push('Amount must be greater than 0');
  } else if (amount > 1_000_000) {
    errors.push('Amount exceeds maximum allowed (₹10,00,000)');
  }

  if (!expense.category) {
    errors.push('Category is required');
  }

  if (!expense.paymentMode) {
    errors.push('Payment mode is required');
  }

  if (expense.comment && String(expense.comment).length > 200) {
    errors.push('Comment must be 200 characters or fewer');
  }

  return { valid: errors.length === 0, errors };
}

/** Validate a planned expense record */
export function validatePlannedExpense(expense) {
  const errors = [];

  if (!expense.date) errors.push('Date is required');

  if (!expense.vendor || String(expense.vendor).trim().length === 0) {
    errors.push('Vendor / payee is required');
  }

  const amount = Number(expense.amount);
  if (isNaN(amount) || amount <= 0) {
    errors.push('Amount must be greater than 0');
  } else if (amount > 10_000_000) {
    errors.push('Amount exceeds maximum allowed');
  }

  if (!expense.description || String(expense.description).trim().length === 0) {
    errors.push('Description is required');
  }

  if (!expense.label) {
    errors.push('Label is required');
  }

  return { valid: errors.length === 0, errors };
}

/** Validate category name for custom addition */
export function validateCategoryName(name) {
  const trimmed = String(name || '').trim();
  if (!trimmed) return { valid: false, error: 'Category name is required' };
  if (trimmed.length > 40) return { valid: false, error: 'Category name too long (max 40 chars)' };
  return { valid: true, error: null };
}

/** Sanitise a string (trim + strip control chars) */
export function sanitiseString(value) {
  if (typeof value !== 'string') return '';
  // Remove control characters
  return value.trim().replace(/[\x00-\x1F\x7F]/g, '');
}
